const PIN_PATH =
  "M32 3C16.5 3 4 15.2 4 30.3c0 11.5 9.6 20.7 20.2 28.4 2.3 1.7 4.6 3.3 6.3 4.6a2.4 2.4 0 0 0 3 0c1.7-1.3 4-2.9 6.3-4.6C50.4 51 60 41.8 60 30.3 60 15.2 47.5 3 32 3Z";
const CHECK_PATH = "M20 30.5l8.2 8.2L45 21.5";

export function LogoMark({ size = 36, variant = "color" }) {
  const white = variant === "white";
  const gradId = white ? "logo-white" : "logo-color";
  return (
    <svg
      viewBox="0 0 64 68"
      width={size}
      height={size * 1.06}
      className="shrink-0"
      aria-hidden="true"
    >
      <defs>
        <linearGradient id={gradId} x1="0" y1="0" x2="0" y2="1">
          {white ? (
            <>
              <stop offset="0%" stopColor="#ffffff" />
              <stop offset="100%" stopColor="#eef5ff" />
            </>
          ) : (
            <>
              <stop offset="0%" stopColor="#5BA2FF" />
              <stop offset="100%" stopColor="#1A73E8" />
            </>
          )}
        </linearGradient>
      </defs>
      <path d={PIN_PATH} fill={`url(#${gradId})`} />
      <path
        d={CHECK_PATH}
        fill="none"
        stroke={white ? "#1A73E8" : "#ffffff"}
        strokeWidth="4.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function Logo({ size = 36, withText = true, variant = "color" }) {
  const white = variant === "white";
  return (
    <div className="flex items-center gap-2.5" data-testid="app-logo">
      <LogoMark size={size} variant={variant} />
      {withText && (
        <div className="leading-none">
          <div
            className={`font-head font-extrabold text-xl tracking-tight ${
              white ? "text-white" : "text-[#0D253F]"
            }`}
          >
            DiabetFlow
          </div>
          <div
            className={`text-[11px] font-medium ${
              white ? "text-blue-100" : "text-[#627D98]"
            }`}
          >
            Rotina Organizada
          </div>
        </div>
      )}
    </div>
  );
}
